/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {RESOURCE_PROPERTY_DECODER as ɵc,ResourcePropertyDecoder as ɵb} from './client/resource-property-decoder';
export {RESOURCE_PROPERTY_ENCODER as ɵe,ResourcePropertyEncoder as ɵd} from './client/resource-property-encoder';
export {ResourceOperationStrategy as ɵf} from './client/shared';
export {RESOURCE_METADATA as ɵa} from './decorator/resource';